import { InputNumber } from "antd";
import { debounce } from "debounce";
import { useEffect, useRef, useState } from "react";
import { FILTER_ID } from ".";
import Icon, { ICON_NAME } from "../../../components/Icon";
import { removeProperty } from "../../../util/varibles/global";
import { useSiteOverview } from "../SiteOverviewContext";
import styles from '../style.module.scss';

const AvgWeight = () => {
    const [avgWeight, setAvgWeight] = useState<[null | number, null | number]>([null, null])
    const [call, set] = useSiteOverview(state => state.unitsFilter[FILTER_ID.AVG_WEIGHT]);
    const timeout = useRef(debounce((avgWeight: [null | number, null | number]) => {
        const [min, max] = avgWeight;
        if (min === null && max === null)
            set(({ unitsFilter: prev }) => ({ unitsFilter: removeProperty(prev, FILTER_ID.AVG_WEIGHT) }))
        else {
            set(({ unitsFilter: prev }) => {
                return {
                    unitsFilter: {
                        ...prev, [FILTER_ID.AVG_WEIGHT]: ({ avg_weight }) => {
                            if (min && avg_weight < min) {
                                return false
                            }
                            return !(max && avg_weight > max);
                        }
                    }
                }
            })
        }
    }, 350));

    useEffect(() => {
        if (call === undefined) {
            setAvgWeight([null, null]);
        }
    }, [call]);

    useEffect(() => timeout.current(avgWeight), [avgWeight]);

    return <div className={styles.avgWeight}>
        <InputNumber
            value={avgWeight[0]}
            placeholder='From Avg. Weight (gr)'
            min={0}
            step={100}
            onChange={min => setAvgWeight([min, (avgWeight[1] && min && min >= avgWeight[1]) ? null : avgWeight[1]])}
            variant='borderless'
        />
        <Icon className='rotate-[180deg]' icon={ICON_NAME.ARROW_LEFT} />
        <InputNumber
            value={avgWeight[1]}
            placeholder='To Avg. Weight (gr)'
            min={0}
            step={100}
            onChange={max => setAvgWeight([(avgWeight[0] && max && max <= avgWeight[0]) ? null : avgWeight[0], max])}
            variant='borderless'
        />
    </div>
}

export default AvgWeight;